import { NOT_FOUND_ROUTE_PATTERN } from '~constants/Constants';

interface ILocalePath {
    langPrefix: string;
    path: string;
}

/* `stripLocalePath` matches lang_prefix in route. Assumes no prepended slash `/` for route.
    i.e. handles 'fr/account/index.tmpl', 'be/fr/sign-up', or 'sign-up'
    => { langPrefix: 'fr/', path: 'account/index.tmpl' }
    => { langPrefix: 'be/fr/', path: 'sign-up' }
    => { langPrefix: '', path: 'sign-up' }
*/
const stripLocalePath = (route: string): ILocalePath => {
    const regex = /(^\w{2}\/\w{2}\/)|(^\w{2}\/)/;
    const matches = route.match(regex);
    let langPrefix = '';
    let path = route;

    if (matches) {
        langPrefix = matches[0] || '';
        path = route.replace(langPrefix, '');
    }

    return { langPrefix, path };
};

export const localeRouteBuilder = (route: string): string => {
    const requestedPath = window.location.pathname.replace('/', '');
    // match langPrefix from the browser URL
    const { langPrefix } = stripLocalePath(requestedPath);
    // match relative path from given route, whether localized or not
    const { path } = stripLocalePath(route);

    return `${langPrefix}${path}`;
};

// Prevent malicious redirect (i.e: "redirectUrl="http://...")
export const getSanitizedRedirectUrl = (redirectUrl: string): string =>
    redirectUrl.startsWith('/') ? redirectUrl : NOT_FOUND_ROUTE_PATTERN;
